import { Link } from "react-router-dom";
import { ArrowLeft, FileSearch } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <nav className="border-b border-slate-200 bg-white">
        <div className="section-container flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5" data-testid="privacy-logo-link">
            <div className="w-8 h-8 rounded-lg overflow-hidden">
              <img src="https://customer-assets.emergentagent.com/job_bid-quality/artifacts/plxbtywa_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202026-03-12%20%D0%B2%2019.39.09.png" alt="AICallFront" className="w-full h-full object-cover" />
            </div>
            <span className="font-heading text-lg font-bold text-[#0F172A] tracking-tight">AICallFront</span>
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm text-slate-600 hover:text-[#0F172A] transition-colors" data-testid="privacy-back-link">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </nav>

      <main className="section-container py-16 md:py-24 max-w-3xl">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-[#0F172A] tracking-tight mb-8">Privacy Policy</h1>
        <p className="text-sm text-slate-500 mb-8">Last updated: December 2025</p>

        <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed">
          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">1. Introduction</h2>
          <p>AICallFront ("we", "our", "us") is committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you use our AI receptionist platform and services at aicallfront.com.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">2. Information We Collect</h2>
          <p>We collect information that you provide directly to us, including:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Business name and contact details when you request a demo or sign up</li>
            <li>Call recordings and conversation transcripts processed by our AI receptionist</li>
            <li>Customer details captured during calls (names, phone numbers, appointment details)</li>
            <li>Calendar and scheduling data when integrated with our platform</li>
            <li>Technical data such as IP addresses, browser type, and usage patterns</li>
          </ul>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">3. How We Use Your Information</h2>
          <p>We use the collected information to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide and improve our AI receptionist and appointment booking services</li>
            <li>Process and handle calls and chats on behalf of your business</li>
            <li>Send you relevant communications about our services</li>
            <li>Ensure the security and integrity of our platform</li>
          </ul>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">4. Data Storage and Security</h2>
          <p>Your data is stored securely within the United Kingdom and European Economic Area. We implement appropriate technical and organisational measures to protect your personal data against unauthorised access, alteration, disclosure, or destruction.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">5. Data Retention</h2>
          <p>We retain your personal data only for as long as necessary to fulfil the purposes for which it was collected, including any legal, accounting, or reporting requirements.</p>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">6. Your Rights</h2>
          <p>Under the UK GDPR and Data Protection Act 2018, you have the right to:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Access your personal data</li>
            <li>Rectify inaccurate personal data</li>
            <li>Request erasure of your personal data</li>
            <li>Object to processing of your personal data</li>
            <li>Request restriction of processing</li>
            <li>Data portability</li>
          </ul>

          <h2 className="font-heading text-xl font-semibold text-[#0F172A] mt-8">7. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p>AICallFront<br />22 Tudor Street, City of London<br />London EC4Y 0AY, UK<br />Email: info@aicallfront.com<br />Phone: +44 20 3917 2500</p>
        </div>
      </main>
    </div>
  );
}
